module.exports = __webpack_public_path__ + "img/xiamenguojiyinhang.b2359b94.png";